// Who's playing: a display name and an optional Instagram handle, kept on this device only (the same record the game
// reads, so signing in on the site carries into every city).
export interface Identity {
  displayName: string;
  instagram: string | null;
  guest: boolean;
}

const KEY = 'cdt.identity';

export function loadIdentity(): Identity | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Identity) : null;
  } catch {
    return null;
  }
}

export function saveIdentity(id: Identity) {
  try {
    localStorage.setItem(KEY, JSON.stringify(id));
  } catch {
    /* storage unavailable — the identity lives for this visit only */
  }
  session = id;
}

export function clearIdentity() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
  session = null;
}

/** the identity for this visit (storage may be off) */
let session: Identity | null = loadIdentity();
export const currentIdentity = () => session ?? loadIdentity();
